import React, { Fragment, useState, useEffect } from "react";
import Paginate from "components/footers/paginate";
import ModalTambahPenyimpanan from "./ModalTambahPenyimpanan";
import { getRequest } from "config/axios";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, setStatus } from "redux/GeneralReducers/GeneralActions";
import {
  decrement,
  increment,
  setFirstPage,
  setLastPage,
} from "utils/pagination";

const Content = () => {
  const [modal, setModal] = useState({ modal: false, penyimpanan: {} });
  const dispatch = useDispatch();
  const { GeneralReducers } = useSelector((state) => state);
  const [dataPenyimpanan, setDataPenyimpanan] = useState(null);
  const { loading, status, msg } = GeneralReducers;

  const getList = (current_page = 1, q = "") => {
    dispatch(setLoading(true));
    getRequest(`egs/master/arsip/penyimpanan?page=${current_page}&per_page=5&q=${q}`)
      .then((res) => {
        dispatch(setLoading(false));
        setDataPenyimpanan(res.data);
        console.log("objecres datat", res.data)
      })
      .catch((err) => {
        dispatch(setLoading(false));
        if (err.request.status === 401) {
          dispatch(setStatus({ status: "401", msg: "Unauthorization" }));
        } else if (err.message === "Network Error") {
          dispatch(setStatus({ status: "401", msg: err.message }));
        } else {
          dispatch(setStatus({ status: "fail", msg: "Gagal mengambil data" }));
        }
      });
  };

  useEffect(getList, []);

  return (
    <Fragment>
      <ModalTambahPenyimpanan
        data={modal}
        getList={getList}
        setModal={setModal}
      />
      <div className="content-title">
        <div>
          <a
            onClick={() =>
              setModal({
                modal: !modal.modal,
                action: "Tambah Child",
              })
            }
            href="# "
            className="btn btn-sm btn-primary"
          >
            <i className="fa fa-plus"></i> Tambah Penyimpanan
          </a>
        </div>
        <div>
          <input
            placeholder="Search"
            type="text"
            className="form-control"
            onChange={(e) => {
              console.log("find", e.target.value)
              getList(1, e.target.value)
            }}
          />
        </div>
      </div>
      <div className="content-body">
        {status === "success penyimpanan" && (
          <>
            <div className="alert alert-success">
              {msg}
              <a
                href="# "
                className="pull-right"
                onClick={() => dispatch(setStatus({ status: null, msg: null }))}
              >
                <i className="fa fa-close"></i>
              </a>
            </div>
          </>
        )}
        {loading && (
          <center colSpan="2">
            <i className="fa fa-spinner fa-pulse fa-fw"></i>
          </center>
        )}
        {/* SKPD */}
        <div
          className="list-parent-child"
          style={{ padding: "0 50px", fontWeight: "bold" }}
        >
          <div>Nama</div>
          <div>Aksi</div>
        </div>
        <div style={{ paddingRight: "20px" }}>
          {!loading &&
            dataPenyimpanan &&
            dataPenyimpanan.items.map((view, i) => {
              return (
                <List
                  data={view}
                  setModal={setModal}
                  key={i}
                  i={i}
                  childs={view.childs}
                />
              );
            })}
        </div>

        {/* END SKPD */}
      </div>
      {dataPenyimpanan && (
        <Paginate
          meta={dataPenyimpanan.meta}
          increment={() =>
            increment(dataPenyimpanan.meta.current_page, getList)
          }
          decrement={() =>
            decrement(dataPenyimpanan.meta.current_page, getList)
          }
          setLastPage={() =>
            setLastPage(dataPenyimpanan.meta.last_page, getList)
          }
          setFirstPage={() => setFirstPage(dataPenyimpanan.meta.from, getList)}
        />
      )}
    </Fragment>
  );
};

export default Content;

const List = ({ data, childs, i, setModal }) => {
  let child = null;

  if (childs) {
    child = childs.map((view, i) => (
      <List
        data={view}
        key={i}
        i={i}
        setModal={setModal}
        childs={view.childs}
      />
    ));
  }
  return (
    <ul style={{ listStyle: "none" }}>
      <li>
        <div className="nested-list">
          <div>
            <i className="fa fa-chevron-right"></i> {data.kode} {data.nama}
          </div>
          <div>
            <a
              href="# "
              onClick={() =>
                setModal({
                  modal: true,
                  action: "Tambah Child",
                  penyimpanan: {
                    parent: data._id,
                    // nama_parent: data.nama,
                  },
                })
              }
              className="btn btn-sm btn-primary mr-1"
            >
              <i className="fa fa-plus "></i>
            </a>
            <a
              href="# "
              onClick={() =>
                setModal({
                  modal: true,
                  action: "ubah",
                  penyimpanan: {
                    id: data._id,
                    kode: data.kode,
                  },
                })
              }
              className="btn btn-sm btn-info mr-1"
            >
              <i className="fa fa-edit "></i>
            </a>
          </div>
        </div>
        {child && child}
      </li>
    </ul>
  );
};
